import { Box, Menu } from '@mui/material';
import { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { selectUserInfoData } from '../../../reducers/userInfoReducer';
import { MenuItemsUser } from '../user-menu/MenuItemsUser';
import { UserSummaryForHeader } from './UserSummaryForHeader';
import usePopover from '../../../hooks/usePopover';
import useNotifications from './useNotifications';
import { useAccountSelectionContext } from '../../account-selection/AccountSelectionContext';

// Keep time-ago libraries out of the initial bundle. This should eventually be replaced
// with a small in-house Intl.RelativeTimeFormat helper so the popover can load normally.
const NotificationsPopover = lazy(() =>
  import('../notification-center/NotificationsPopover').then((m) => ({
    default: m.NotificationsPopover,
  })),
);

const UserMenu = () => {
  const userInfo = useSelector(selectUserInfoData);
  const { isPopoverOpen, closePopover, openPopover, anchorElement, anchorRef } = usePopover();
  const { openAccountSelection } = useAccountSelectionContext();
  const { notifications, totalUnread } = useNotifications();
  const hasUnreadNotifications = totalUnread > 0;
  const {
    isPopoverOpen: isNotificationsPopoverOpen,
    closePopover: closeNotificationsPopover,
    openPopover: openNotificationsPopover,
  } = usePopover();

  return (
    <Box>
      <Box
        ref={anchorRef}
        id="basic-button"
        aria-controls={isPopoverOpen ? 'user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isPopoverOpen ? 'true' : undefined}
        onClick={openPopover}
        sx={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <UserSummaryForHeader
          user={userInfo}
          isActive={isPopoverOpen}
          hasUnreadNotifications={hasUnreadNotifications}
        />
      </Box>

      <Menu
        id="user-menu"
        anchorEl={anchorElement}
        open={isPopoverOpen}
        onClose={() => closePopover()}
        MenuListProps={{
          'aria-labelledby': 'user-menu-button',
        }}
        slotProps={{
          paper: {
            sx: (theme) => ({
              marginTop: 0,
              width: '320px',
              boxShadow: theme.shadows[7],

              '& .MuiDivider-root': {
                marginTop: '0',
                marginBottom: '4px',
              },
            }),
          },
        }}
        anchorOrigin={{ vertical: 52, horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItemsUser
          closeMenu={closePopover}
          openNotificationsPopover={openNotificationsPopover}
          isNotificationsPopoverOpen={isNotificationsPopoverOpen}
          hasUnreadNotifications={hasUnreadNotifications}
          openAccountSelectionDialog={openAccountSelection}
        />
      </Menu>

      {isNotificationsPopoverOpen && (
        <Suspense>
          <NotificationsPopover
            notifications={notifications}
            onClose={closeNotificationsPopover}
            anchorEl={anchorElement}
            isOpen={isNotificationsPopoverOpen}
            closeUserMenu={closePopover}
          />
        </Suspense>
      )}
    </Box>
  );
};

export default UserMenu;
